/**
 * @generated SignedSource<<064e9abe2ee87382e8982c28fb6cd644>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineTemplateListItem_Routine$data = {
  readonly id: string;
  readonly isWorkspaceOwner: boolean;
  readonly orgTopic: {
    readonly name: string;
  } | null;
  readonly workspaceOwnerName: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineTemplateListItemContent_routine">;
  readonly " $fragmentType": "WorkspaceRoutineTemplateListItem_Routine";
};
export type WorkspaceRoutineTemplateListItem_Routine$key = {
  readonly " $data"?: WorkspaceRoutineTemplateListItem_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineTemplateListItem_Routine">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutineTemplateListItem_Routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "isWorkspaceOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "workspaceOwnerName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrgTopic",
      "kind": "LinkedField",
      "name": "orgTopic",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceRoutineTemplateListItemContent_routine"
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "69bef90e7e1855a2bbe0e08c8ea950b8";

export default node;
